import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDvCdzWJElMBdmVyVJHth5iohNPQkT_5BQ",
    authDomain: "engineering-college-finder-ark.firebaseapp.com",
    projectId: "engineering-college-finder-ark",
    storageBucket: "engineering-college-finder-ark.appspot.com",
    messagingSenderId: "579203198728",
    appId: "1:579203198728:web:a5072df132d8a2fb5e46bd",
    measurementId: "G-GV76NHFR7D"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const firestore = firebase.firestore();

export default firebase;
